<div data-test="content" class="container">
  <div class="padding-workaround">
    <div *ngIf="showDeadlineWarning" class="deadline-warning" role="alert">
      <strong>ATENÇÃO:</strong> a partir de 11/07 o prazo para envio dos documentos passa a ser de <strong>2 dias úteis</strong>,
      contados da <strong>data de emissão</strong>. Documentos fora do prazo serão recusados.
    </div>
    <div class="content">
      <div [innerHTML]="contentBody"></div>
      <ng-container *ngIf="type !== 'complete'">
        <a *ngIf="!!term?.content?.complete?.body" (click)="showCompleteRules()"
        class="complete-link">
          Ver regras completas
        </a>
        <div class="checkbox-container" fxLayout="column" fxLayoutAlign="space-around start" fxLayoutGap="16px">
          <mat-checkbox data-test="checks" *ngFor="let c of termControls.controls; let i = index"
            [formControl]="c" color="primary" [checked]="c.value">
            {{term?.conditions[i]}}
          </mat-checkbox>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="button-container">
    <button mat-raised-button data-test="submit" class="closecare-button primary-bg"
            [disabled]="termControls.invalid" (click)="saveOrClose()">
      {{buttonLabel}}
    </button>
  </div>
</div>
